import { render, staticRenderFns } from "./DeclinadoEnEspera.vue?vue&type=template&id=c705e562&"
import script from "./DeclinadoEnEspera.vue?vue&type=script&lang=js&"
export * from "./DeclinadoEnEspera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports